// Export all themes from a single file
import { baseCardTheme } from "./baseCardTheme"
import { cardDesign5Theme } from "./cardDesign5Theme"
import { cardDesign5PreviewTheme } from "./cardDesign5PreviewTheme"
import { CardDesign5FloatingButtonTheme } from "./CardDesign5FloatingButtonTheme"
import { fullCardTheme as cardDesign2Theme } from "./cardDesign2Theme"
import { fullCardTheme as cardDesign3Theme } from "./cardDesign3Theme"
import { fullCardTheme as cardDesign4Theme } from "./cardDesign4Theme"
import { fullCardTheme as defaultCardTheme } from "./defaultCardTheme"

// Export the themes
export { baseCardTheme, cardDesign5Theme, cardDesign5PreviewTheme, CardDesign5FloatingButtonTheme }

export const CARD_THEMES = {
    default: defaultCardTheme,
    design2: cardDesign2Theme,
    design3: cardDesign3Theme,
    design4: cardDesign4Theme,
    design5: cardDesign5Theme,
    design5Preview: cardDesign5PreviewTheme,
    design5FloatingButton: CardDesign5FloatingButtonTheme
}